var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteIconLiked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3773_7604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 11.0184C16.7624 10.3365 17.7563 9.97231 18.7783 10.0006C19.8002 10.0289 20.7725 10.4475 21.4953 11.1704C22.2176 11.8925 22.6362 12.8636 22.6655 13.8845C22.6947 14.9054 22.3324 15.8988 21.6527 16.6611L15.9993 22.3224L10.3473 16.6611C9.66685 15.8984 9.30415 14.9041 9.33371 13.8824C9.36326 12.8607 9.78283 11.889 10.5063 11.167C11.2297 10.4449 12.2022 10.0271 13.2239 9.99951C14.2457 9.97188 15.2393 10.3365 16.0007 11.0184Z",
    fill: "#E50C7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3773_7604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIconLiked);
export default __webpack_public_path__ + "static/media/favouriteIconLiked.cde75cefabf3d941d3ac692907634f93.svg";
export { ForwardRef as ReactComponent };